module.exports = __webpack_public_path__ + "img/fk.4e9526a.svg";